/**
 * CSV Column Definitions
 * Defines column structures for different data exports
 */

import { CSVColumn, formatCurrencyForCSV, formatDateForCSV } from './csvExport';

/**
 * Transaction CSV columns
 */
export const transactionCSVColumns: CSVColumn[] = [
  {
    key: 'method',
    header: 'Method'
  },
  {
    key: 'stablecoin_amount',
    header: 'Stablecoin & Amount',
    formatter: formatCurrencyForCSV
  },
  {
    key: 'status',
    header: 'Status'
  },
  {
    key: 'transaction_id',
    header: 'Transaction Hash'
  },
  {
    key: 'referenceIds',
    header: 'Reference IDs'
  },
  {
    key: 'payout_amount',
    header: 'Payout Currency & Amount',
    formatter: formatCurrencyForCSV
  },
  {
    key: 'date',
    header: 'Transaction Date',
    formatter: formatDateForCSV
  }
];

/**
 * Credit Fee Payments CSV columns
 */
export const creditFeePaymentCSVColumns: CSVColumn[] = [
  {
    key: 'method',
    header: 'Method'
  },
  {
    key: 'stablecoin_amount',
    header: 'Stablecoin & Amount',
    formatter: formatCurrencyForCSV
  },
  {
    key: 'status',
    header: 'Status'
  },
  {
    key: 'transaction_id',
    header: 'Transaction Hash'
  },
  {
    key: 'payout_amount',
    header: 'Payout Currency & Amount',
    formatter: formatCurrencyForCSV
  },
  {
    key: 'date',
    header: 'Transaction Date',
    formatter: formatDateForCSV
  }
];
